const titleSize = 32;
const subtitleSize = 24;
const subSubTitleSize = 20;
const contentSize = 16;

const contentColor = 'rgba(0 ,0, 0, 0.65)';

export { titleSize, contentSize, subtitleSize, contentColor, subSubTitleSize };